import React, { useEffect, useState, useContext, useRef} from 'react';
import { Link } from "react-router-dom";
import Layout from '../../../parts/Layout';
import { httpRequest } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import Loader from '../../../parts/Loader';
import CategoryFormModal from '../../../modals/CategoryFormModal';
import initTreeView from '../../../../services/initTreeView';
import BoardingPreview from './BoardingPreview';
import ProfileContext from '../../../../services/profileContext';
import QRScannerModal from '../../../parts/QRScannerModal';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import Dropdown from 'react-bootstrap/Dropdown'
import { MdOutlineQrCodeScanner } from "react-icons/md";
 
export default function BoardingList ({viewer = 'admin', menu = 'manage-boarding', page_title = "Manage Boarding"}){
    const {
        account
    } = useContext(ProfileContext);
    const toast = useRef(null);
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [booking_item_id, setBookingItemID] = useState('');
    const [show_preview, setShowPreview] = useState(0);
    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });
    const [selected_member_data, setMemberData] = useState('');
    const [selected_member_id, setMemberID] = useState('');
    const [selected_member_index, setMemberIndex] = useState('');
    const [show_scanner, setShowScanner] = useState(0);
    const [vehicleData, setVehcleData] = useState({});

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createShipBookingHubUrl('booking/manifest'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res)
                setLoading(0)
                displayDataTable(res)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function fetchData(qr_code){
        if(!qr_code) return

        setLoading(1)

        const url = helpers.createShipBookingHubUrl(`booking/manifest/${qr_code}`)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setVehcleData(res)
                setLoading(0)
                setShowPreview(1)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Ship'
        if(ids.length > 1){
            title = 'Delete Categories'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createShipBookingHubUrl('ships/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="Search for a vehicle plate number or scan a booking QR code to begin."
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column field="plate_number" header="Plate Number" />
                <Column 
                    body={({brand, model_name})=> `${brand} | ${model_name}`} 
                    header="Vehicle Details" 
                />
                <Column 
                    body={({departure_time})=> helpers.formatManifestDateTime(departure_time)} 
                    header="Departure Date/Time" 
                />
                <Column field="booking_ref" header="Booking Ref" />
                <Column field="booking_date" header="Booking Date" />
                <Column field="customer_name" header="Owner/Consignee" />
                <Column 
                    header="Status" 
                    body={({is_onboarded})=> displayStatusBadge(is_onboarded, is_onboarded ? 'Boarded' : 'Pending Boarding')}
                />
                <Column 
                    header="Status" 
                    style={{ maxWidth: '150px' }}
                    body={({is_onboarded, schedule_id, id})=> is_onboarded ? 
                        <button type='button' className='btn btn-secondary' disabled>Board Vehicle</button> : 
                        <button type='button' className='btn btn-info' onClick={()=> handleOnboard(id, schedule_id)} disabled={!helpers.checkPermissions(['superAdmin', 'shipOnBoarding'], account?.permissions)}>Board&nbsp;Vehicle</button> 
                    }
                />
            </DataTable>
        )

    }

    function displayStatusBadge(status_id = '', status_name = ''){
        let label = '';
        let class_name = ''

        switch (Number(status_id)) {
            case 1://Pending
                class_name = "bg-success"
                break;
            default:
                class_name = "text-light bg-warning"
        }

        if(class_name){
            // label = <span className={`text-center rounded p-2 text-white text-sm ${class_name}`}>{status_name}</span>
            label = <span className={`text-center rounded px-2 py-1 text-white text-sm ${class_name} ml-2`}>{status_name}</span>
        }

        return label;
    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };
    
    function handleScanQR(e){
        setShowScanner(1)
    }

    function handleOnboard(id, schedule_id){
        Swal.fire({
            title: 'Vehicle Onboarding',
            text: 'Are you sure you want to onboard this vehicle?',
            showCancelButton: true,
            showConfirmButton: true,
            closeOnCancel: true,
            //showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isConfirmed) {

                proceedOnboard(id, schedule_id)
                // setLoading(1)

                // const url = helpers.createShipBookingHubUrl('onboard')
                // httpRequest(url, 'POST', {
                //     postdata: {
                //         "id": id,
                //         "schedule_id": schedule_id
                //     },
                // }, true)
                // .then((res) => {
                //     setLoading(0)
                    
                //     toast.current.show({
                //         severity: 'success', 
                //         summary: 'Success', 
                //         detail: res.message, 
                //         life: 10000 
                //     });
                //     fetchDataList()
                // })
                // .catch((err) => {
                //     console.log(err)
                //     setLoading(0)
                //     toast.current.show({
                //         severity: 'error', 
                //         summary: 'Notice', 
                //         detail: err.message, 
                //         life: 10000 
                //     });
                // }); 

            }
        })
    }

    function handleProceed(e){
        setShowPreview(0)
        setBookingItemID('')
        proceedOnboard(e.id, e.schedule_id)
    }

    function proceedOnboard(id, schedule_id){
        setLoading(1)

        const url = helpers.createShipBookingHubUrl('onboard')
        httpRequest(url, 'POST', {
            postdata: {
                "id": id,
                "schedule_id": schedule_id
            },
        }, true)
        .then((res) => {
            setLoading(0)
            
            toast.current.show({
                severity: 'success', 
                summary: 'Success', 
                detail: res.message, 
                life: 10000 
            });
            fetchDataList()
        })
        .catch((err) => {
            console.log(err)
            setLoading(0)
            toast.current.show({
                severity: 'error', 
                summary: 'Notice', 
                detail: err.message, 
                life: 10000 
            });
        }); 

    }

    function getQrValue(url) {
        const match = url.match(/\/qr\/([^\/\?]+)/);
        return match ? match[1] : null;
    }

    function handleQR(e){
        let qr_value = e
        setBookingItemID(qr_value)
        setShowPreview(1)
        //fetchData(qr_value)
    }

    return (
        <>
        <Toast ref={toast} position="top-right" />
        
        <QRScannerModal 
            is_show={show_scanner}
            setShow={setShowScanner}
            handleResult={handleQR}
        />

        <BoardingPreview 
            is_show={show_preview} 
            setShow={setShowPreview} 
            handleSave={handleProceed} 
            reference_id={booking_item_id}
        />
        
        <Layout page_title={page_title} menu={menu}>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <InputText className="w-100" placeholder="Search Vehicle" onChange={search} />
                                    </div>
                                    <div className="col-lg-9  d-flex align-items-center justify-content-end">
                                        <div className='d-flex justify-content-end py-2'>
                                            {selected_items.length ?
                                            <Dropdown className='mr-3'>
                                                <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item 
                                                        key="delete" 
                                                        className={helpers.checkPermissions(['superAdmin', 'shipDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                                        disabled={!helpers.checkPermissions(['superAdmin', 'shipDelete'], account?.permissions)}
                                                        onClick={(e) => triggerAction(selected_items)}
                                                    ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> : ''}
                                            <button type='button' className='btn btn-primary float-rights' onClick={handleScanQR} disabled={!helpers.checkPermissions(['superAdmin', 'shipOnBoarding'], account?.permissions)}>
                                                <MdOutlineQrCodeScanner size={20} className='mr-2'/>Scan QR
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}